export enum Routing {
  HOME = '/home',

  // signed out
  SIGN_IN = '/login',
  REGISTER = '/register',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',

  // me
  EDIT_AVATAR = '/home/edit-avatar',
  UPLOAD_GALLERY_IMAGE = '/home/upload-gallery-image',
  EDIT_PROFILE = '/home/edit-profile',
  EDIT_IMAGE = '/home/edit-image/:id',
  REGISTRATION_CODES = '/home/registration-codes',
  NOTIFICATIONS = '/home/notifications',

  // packs
  PACKS = '/home/packs',
  PACK = '/home/packs/:id',
  PACK_INVITE_MEMBER = '/home/packs/:id/member-invite',
  PACK_CREATE = '/home/create-pack',

  // groups
  GROUPS = '/home/groups',
  GROUP = '/home/groups/:id',
  GROUP_CREATE = '/home/create-group',

  // profiles
  PROFILES = '/home/profiles',
  PROFILE = '/home/profiles/:id'
}
